// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"063c6de6","455":"1a91f195","977":"8a23ed15"}[chunkId] + ".chunk.js";
};